export function date(state) {
  return state.date;
}

export function invoices(state) {
  return state.invoices;
}
